import {Card} from '@material-ui/core';
import React, {ReactNode} from 'react';
import 'Shared/components/AllstateCard.sass';
import './Card.sass';

type CardProps = {
  children: ReactNode;
  className?: string;
  title: string;
  padding?: boolean;
};

const AllstateCard = (props: CardProps) => (
  <Card className={'allstate-card ' + (props.className || '')}>
    <div className="card__header">
      <span className="card__title">{props.title}</span>
    </div>
    <div
      style={{
        padding: props.padding ? '1em' : '',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
        className="card__rows"
      >
        {props.children}
      </div>
    </div>
  </Card>
);

export default AllstateCard;
